/**
 * Map a notification category to the most relevant dashboard route.
 * Returns null for system notifications (no meaningful destination).
 */
export function getNotificationRoute(cat: 'payment' | 'circle' | 'verification' | 'system'): string | null {
  switch (cat) {
    case 'payment': return '/dashboard/billing'
    case 'circle': return '/dashboard/pending-payments'
    case 'verification': return '/dashboard/company-profile'
    case 'system': return null
  }
}
